let prefix = `auth`;

export const LOGIN = `${prefix}/login`;
export const SIGNUP = `${prefix}/signup`;
export const LOGOUT = `${prefix}/logout`;
